module.exports = __webpack_public_path__ + "static/media/BasqueAudiovisual.5425ab6d.svg";